// -*- mode: jsx;-*-

import { LoadingEllipsis } from '../common/LoadingEllipsis.js';
import { Svg } from '../common/Svg.js';
import { SavedSearch } from './SavedSearch.js';
import { TrackSectionView } from '../common/TrackSectionView.js';

export function renderSavedSearches(favoritesLoaded, favorites, searchesLoaded, savedSearches, baseSearchURL) {
    let hasSearches;
    let searchesContent = <LoadingEllipsis />;
    const favoritesUrl = secureBaseURL + 'donors/favorites.html';

    if (favoritesLoaded) {
        if (favorites.searchHashes.length > 0) {
            if (searchesLoaded) {
                if (savedSearches && savedSearches.length > 0) {
                    hasSearches = true;
                    searchesContent =
                        <TrackSectionView sectionName="Saved searches">
                            <div className="activity-header">
                                <h3>
                                    Your Saved Searches
                                </h3>
                                <p>New projects since you last visited
                                    <span className="tooltip-wrapper">
                                        <Svg icon="help"/>
                                        <span className="hover-tooltip">You can save a search by browsing for projects and using<Svg icon="bookmark"/><b>Save search</b>. Searches you&apos;ve saved will show up here in order of most recently visited searches along with a notification on how many new projects have been posted since.</span>
                                    </span>
                                </p>
                            </div>
                            <div className="searches-container">
                                {savedSearches.map(search =>
                                    <SavedSearch search={search} key={search.donorMMIId} baseSearchURL={baseSearchURL}/>,
                                )}
                                <a tabindex="0" role="button" aria-label="View all saved searches" className="saved-search-link" href={favoritesUrl + '#searches'}>View all saved
                                    searches</a>
                            </div>
                        </TrackSectionView>;
                } else {
                    hasSearches = false;
                    searchesContent =
                        <div>
                            <a href={favoritesUrl + '#searches'}>View all saved searches</a>
                            <div className="search-empty">
                                <div className="no-searches">
                                    <span>Your saved searches don&apos;t currently have any results</span>
                                </div>
                            </div>
                        </div>;
                }
            }
            // Still loading
        } else {
            hasSearches = false;
            searchesContent =
                <div className="search-empty">
                    <div className="no-searches">
                        <h3>
                            Interested in a certain type of project?
                        </h3>
                        <span>Search for topic or location you want to keep track of and use <span className="follow-example"><Svg icon="bookmark"/>Save search</span>. We'll notify you here when any newly posted projects match that search.</span>
                    </div>
                    <a className="button-secondary small" href={baseSearchURL}>Start a search</a>
                </div>;
        }
    }

    return { hasSearches, searchesContent };
}
